import axiosInstance from './axiosInstance';

/**
 * 내 알림 목록
 * @returns {NotificationDto[]}
 */
export const getNotifications = async () => {
  const res = await axiosInstance.get('/api/notifications');
  return res.data;
};

/**
 * 메일 수신 거부 — 로그인 없이 토큰만으로 동작한다.
 *
 * 메일을 여는 시점에는 로그인돼 있지 않은 경우가 많아, 이 두 요청은 인증을 타지 않는다.
 * 여러 번 불러도 결과가 같다(멱등).
 *
 * @param {string} token 메일 링크에 담긴 서명된 토큰
 * @returns {{ field?: string }} 꺼진 알림 종류 (서버가 알려주면)
 */
export const unsubscribeByToken = async (token) => {
  const res = await axiosInstance.post('/api/notifications/unsubscribe', { token });
  return res.data ?? {};
};

/** 수신 거부 취소 — 실수로 눌렀을 때 되돌린다 */
export const resubscribeByToken = async (token) => {
  const res = await axiosInstance.post('/api/notifications/resubscribe', { token });
  return res.data ?? {};
};
